import { ComponentStyleConfig } from '@chakra-ui/react';
import { getColorVar, mode } from '@chakra-ui/theme-tools';

const bgLayerMap: Map<string, string> = new Map([
  ['base', 'layer.0'],
  ['first', 'layer.1'],
  ['second', 'layer.2'],
  ['third', 'layer.3'],
]);

const borderLayerMap: Map<string, string> = new Map([
  ['base', 'border.layer.0'],
  ['first', 'border.layer.1'],
  ['second', 'border.layer.2'],
  ['third', 'border.layer.3'],
]);

export const dataListStyles: ComponentStyleConfig = {
  parts: [
    'container',
    'header',
    'body',
    'divider',
    'item',
    'selectedItem',
    'pagination',
    'paginationButton',
  ],
  baseStyle: (props) => {
    const { layerStyle = 'first' } = props;
    const bg = bgLayerMap.get(layerStyle);
    const border = borderLayerMap.get(layerStyle);
    return {
      container: {
        bg: bg,
        h: '100%',
        w: '100%',
        display: 'flex',
        flexDir: 'column',
        justifyContent: 'space-between',
      },
      header: {
        bg: bg,
        bgColor: bg,
        py: 3.5,
        px: 4,
      },
      body: {
        display: 'flex',
        flexDir: 'column',
        h: 'calc(100% - var(--chakra-space-12))',
        overflowX: 'hidden',
        overflowY: 'auto',
      },
      divider: {
        borderColor: border,
      },
      item: {
        px: 5, // not correct, but resolves alignment issue with the page size selection
        py: 3,
        w: 'full',
        textAlign: 'left',
        cursor: 'pointer',
        position: 'relative',
        _hover: {
          bg: 'tint.hover',
        },
      },
      selectedItem: {
        px: 5, // not correct, but resolves alignment issue with the page size selection
        py: 3,
        bg: 'tint.primary',
        w: 'full',
        textAlign: 'left',
        cursor: 'pointer',
        position: 'relative',
        _hover: {
          bg: `color-mix(in srgb,${getColorVar(props.theme, 'tint.primary')},${getColorVar(props.theme, 'tint.hover')})`,
        },
        _after: {
          content: '""',
          position: 'absolute',
          top: 0,
          bottom: 0,
          left: 0,
          width: '3px',
          bg: 'state.selected',
        },
      },
      pagination: {
        position: 'sticky',
        boxShadow: `0px -5px 10px -5px var(--chakra-colors-${mode(
          'gray-50',
          'gray-900',
        )(props)})`,
        display: 'flex',
        px: 4,
        py: 2,
        alignItems: 'center',
        justifyContent: 'space-between',
        ...(props.isLined && {
          borderTop: 'solid 1px',
          borderColor: mode('gray.50', 'gray.800')(props),
        }),
        height: 12,
      },
    };
  },
};
